<template>
  <div ref="formWrapperRef" class="namenecklace-form">
    <div 
    v-if="fontVisual !== 'yes'"
    class="namenecklace-form__input">
      <div class="namenecklace-form__input--inner namenecklace-value">
        <input
          ref="singleInput"
          type="text"
          :id="props.id"
          :placeholder="props.placeholderText"
          class="namenecklace-input"
          :class="props.fontSelected"
          :name="props.nameinput"
          v-model="inputValue"
          @beforeinput="handleBeforeInput"
          @input="handleInput"
          @compositionend="handleInput"
          @keydown.enter.prevent
        />

        <span ref="symbolsButtonRef" class="namenecklace-form__input--symbols" @click="toggleSymbols">
          <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.5 2.14953C9.85489 2.14953 11.1794 2.5513 12.3059 3.30404C13.4325 4.05678 14.3105 5.12668 14.829 6.37844C15.3475 7.6302 15.4832 9.0076 15.2188 10.3365C14.9545 11.6653 14.3021 12.886 13.344 13.844C12.386 14.8021 11.1653 15.4545 9.83646 15.7188C8.5076 15.9832 7.1302 15.8475 5.87844 15.329C4.62668 14.8105 3.55678 13.9325 2.80404 12.8059C2.0513 11.6794 1.64953 10.3549 1.64953 9C1.65164 7.18379 2.37406 5.44257 3.65832 4.15832C4.94257 2.87406 6.68379 2.15164 8.5 2.14953ZM8.5 1.03125C6.92393 1.03125 5.38325 1.49861 4.0728 2.37423C2.76235 3.24984 1.74097 4.49439 1.13784 5.95049C0.534699 7.40659 0.376892 9.00884 0.684367 10.5546C0.991843 12.1004 1.75079 13.5203 2.86524 14.6348C3.97969 15.7492 5.39959 16.5082 6.94537 16.8156C8.49116 17.1231 10.0934 16.9653 11.5495 16.3622C13.0056 15.759 14.2502 14.7377 15.1258 13.4272C16.0014 12.1167 16.4688 10.5761 16.4688 9C16.4688 6.88656 15.6292 4.85967 14.1348 3.36524C12.6403 1.87081 10.6134 1.03125 8.5 1.03125Z"
              fill="#9D9D9D" />
            <path
              d="M8.5 13.4439C7.7786 13.4325 7.06725 13.2729 6.41015 12.975C5.75306 12.677 5.16424 12.2472 4.68031 11.712C4.62704 11.6545 4.58671 11.5862 4.56201 11.5117C4.53732 11.4373 4.52884 11.3584 4.53714 11.2804C4.54545 11.2024 4.57034 11.1271 4.61015 11.0595C4.64996 10.9919 4.70377 10.9337 4.76797 10.8886H4.7839C4.89285 10.8134 5.02517 10.7798 5.1568 10.7939C5.28843 10.8081 5.4106 10.869 5.50109 10.9656C5.89581 11.4027 6.37888 11.7509 6.91833 11.9872C7.45777 12.2235 8.04126 12.3425 8.63015 12.3363C9.17537 12.309 9.70979 12.1741 10.2026 11.9393C10.6954 11.7046 11.1369 11.3745 11.5016 10.9683C11.5917 10.8712 11.714 10.8099 11.8458 10.7957C11.9775 10.7816 12.11 10.8155 12.2187 10.8913H12.2347C12.2988 10.9357 12.3526 10.9933 12.3926 11.0602C12.4327 11.1271 12.4579 11.2018 12.4667 11.2792C12.4755 11.3567 12.4677 11.4352 12.4437 11.5093C12.4197 11.5835 12.3801 11.6517 12.3277 11.7094C11.864 12.2277 11.3012 12.6479 10.6726 12.9454C10.0439 13.2428 9.36215 13.4114 8.66734 13.4413C8.6089 13.4439 8.55312 13.4439 8.5 13.4439Z"
              fill="#9D9D9D" />
            <path
              d="M4.5315 6.8883C4.5315 7.50591 5.03218 8.00658 5.64979 8.00658C6.2674 8.00658 6.76807 7.50591 6.76807 6.8883C6.76807 6.27069 6.2674 5.77002 5.64979 5.77002C5.03218 5.77002 4.5315 6.27069 4.5315 6.8883Z"
              fill="#9D9D9D" />
            <path
              d="M10.2319 6.8883C10.2319 7.50591 10.7326 8.00658 11.3502 8.00658C11.9678 8.00658 12.4685 7.50591 12.4685 6.8883C12.4685 6.27069 11.9678 5.77002 11.3502 5.77002C10.7326 5.77002 10.2319 6.27069 10.2319 6.8883Z"
              fill="#9D9D9D" />
          </svg>
        </span>

        <div class="namenecklace-form__input--maxlength">
          <span class="text-remaider">{{ inputLength }}</span>/{{ currentMaxLength }}
        </div>
      </div>


      <div ref="symbolsPanelRef" class="nameneckale-symbols" :class="{ active: showSymbolsPanel, added_icon: isIconAdded }">
        <span v-for="(icon, index) in icons" :key="index" @click="insertSymbol(icon.value)" :data-value="icon.value">
          {{ icon.value }}
        </span>
      </div>
    </div>

    

    <div class="preview-box" 
    v-if="fontVisual === 'yes'"
    >
  <div class="preview-header">
    <span class="preview-label">Font Preview </span>
  </div>

  <div class="preview-canvas namenecklace-value" @click="focusInput">
  <textarea
  :maxlength="currentMaxLength"
  ref="previewInput"
  class="type-area"
  :name="props.nameinput"
  v-model="inputValue"
  @beforeinput="handleBeforeInput"
  @input="handlePreviewInput"
  @compositionend="handlePreviewInput"
  @keydown.enter.prevent
  @focus="onFocus"
  @blur="onBlur"
/>

  <div
  v-if="inputValue"
  class="char-render-wrapper"
>
  <div
    class="char-render"
    :class="[
      props.fontSelected,
      {
        'bold-style': ['bold','cnbold'].includes(props.fontSelected),
        'cursive-style': ['cursive','cncursive'].includes(props.fontSelected),
        'is-descender': /[gjpqy]/.test(inputValue)
      }
    ]"
    
    :style="{
      backgroundImage: currentGradient,
      fontFamily: props.fontSelected
    }"
  >
    <template v-for="(segment, index) in previewSegments" :key="index">
      <span v-if="segment.type === 'icon'" class="necklace-icon">{{ segment.value }}</span>
      <template v-else-if="index === 0">
        <span class="first_text" :style="{fontFamily: props.fontSelected}">{{ getGraphemes(segment.value)[0] }}</span>{{ getGraphemes(segment.value).slice(1).join('') }}
      </template>
      <template v-else>{{ segment.value }}</template>
    </template>
    
  </div>

  <span
    v-if="focused"
    class="blink-cursor small"
  />
</div>
  <span v-else-if="focused" class="blink-cursor" />
  <div v-else class="placeholder-text">
    Click here and type your character
  </div>
</div>

  <div class="preview-hint">
    {{ hint }}
  </div>
</div>

    <div 
    v-else
    class="namenecklace-form__preview" 
    :class="[
      props.fontSelected,
      {
        'namenecklace-form__preview-fontvisuals': fontVisual === 'yes'
      },
      `font-${props.fontSelected}`
    ]" :style="fontVisual === 'yes' ? {} : { fontFamily: props.fontSelected }">
      <template v-for="(segment, index) in previewSegments" :key="index">
        <span v-if="segment.type === 'icon'" class="necklace-icon">{{ segment.value }}</span>
        <template v-else-if="index === 0">
          <span class="first_text" :style="fontVisual === 'yes' ? {} : { fontFamily: props.fontSelected }">{{ getGraphemes(segment.value)[0] }}</span>{{ getGraphemes(segment.value).slice(1).join('') }}
        </template>
        <template v-else>{{ segment.value }}</template>
      </template>
    </div>



  </div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted, onUnmounted, onBeforeUnmount, nextTick, watch } from 'vue'
const emit = defineEmits<{
  (e: 'input-name', index: number | string, value: string): void
  (e: 'update-name', index: number | string, value: string): void
}>()

const props = withDefaults(
  defineProps<{
    maxlength?: string
    symbols?: string
    placeholderText?: string
    nameinput?: string
    valueinput?: string
    fontVisual?: string
    fontSelected?: string
    colorSelected?: string
    id?: string
    isChina?: string
    index?: string | number
    limit_icon?: number | string
    productID?: number | string
  }>(),
  {
    maxlength: '',
    symbols: '',
    placeholderText: '',
    nameinput: '',
    valueinput: '',
    fontVisual: '',
    fontSelected: '',
    colorSelected: 'rose-gold',
    id: '',
    isChina: '',
    index: '0',
    limit_icon: 1,
    productID: 0
  }
)

const limit_icon = computed(() => {
  const val = Number(props.limit_icon)
  return isNaN(val) ? 1 : val
})


//  preview fontvisula
const focused = ref(false)
const singleInput = ref<HTMLInputElement>()
const previewInput = ref<HTMLTextAreaElement>()

const gradients: Record<string, string> = {
  'rose-gold':
    'linear-gradient(135deg,#ffd6d6 0%,#f0a0a0 30%,#e07070 55%,#f5c0c0 75%,#c97070 100%)',
  'white-gold':
    'linear-gradient(135deg,#ffffff 0%,#d8d8d8 30%,#a0a0a0 55%,#e8e8e8 75%,#b0b0b0 100%)',
  'yellow-gold':
    'linear-gradient(135deg,#fff5b0 0%,#f5d060 30%,#c9a227 55%,#ffe980 75%,#b8880f 100%)'
}

const labels: Record<string, string> = {
  'rose-gold': 'Rose Gold',
  'white-gold': 'White Gold',
  'yellow-gold': 'Yellow Gold'
}

const currentGradient = computed(
  () => gradients[props.colorSelected] ?? gradients['rose-gold']
)

const fontClass = computed(() =>
  props.fontSelected === 'bold'
    ? 'bold-style'
    : 'cursive-style'
)

const hint = computed(() => {
  if (!inputValue.value) {
    if (Number(currentMaxLength.value) > 0) {
    return `Type directly in the box above — max ${currentMaxLength.value} character`
    } else {
      return `Type directly in the box above `
    }
    
  }

  return `Showing ${
    props.fontSelected === 'bold' ? 'Bold' : 'Cursive'
  } · ${labels[props.colorSelected]} — switch above to compare`
})

const focusInput = () => {
    previewInput.value?.focus()
}

const onFocus = () => {
  focused.value = true
}

const onBlur = () => {
  focused.value = false
}

// ─── Symbols & Validation Helpers ─────────────────────────────────────────────
const normalize = (str: string) =>
  str.replace(/[\u200B-\u200D\uFEFF]/g, '');

const allowedSymbols = computed(() => {
  if (!props.symbols) return []
  return props.symbols
    .split(',')
    .map(symbol => normalize(symbol.trim()))
    .filter(Boolean)
})

const getGraphemes = (str: string): string[] => {
  if (typeof Intl !== 'undefined' && Intl.Segmenter) {
    const segmenter = new Intl.Segmenter(undefined, { granularity: 'grapheme' });
    return Array.from(segmenter.segment(str), s => s.segment);
  }
  return Array.from(str);
}

const isSymbolCharacter = (grapheme: string, cleanGrapheme: string): boolean => {
  const symbolOrEmojiRegex = /[\p{Extended_Pictographic}\p{So}\p{Sk}\p{Sm}\p{Symbol}]/u;
  return allowedSymbols.value.includes(cleanGrapheme) || symbolOrEmojiRegex.test(grapheme);
}

const countIcons = (str: string): number => {
  if (!str) return 0;
  const graphemes = getGraphemes(str);
  return graphemes.filter(grapheme => isSymbolCharacter(grapheme, normalize(grapheme))).length;
}

const whitespaceAllowedProductIds = ['734106'];

const chineseRegex = /[\u4E00-\u9FFF\u3400-\u4DBF\uF900-\uFAFF]/;

const isGraphemeValid = (
  grapheme: string,
  currentIconCount: number,
  maxIcons: number
): { valid: boolean; isIcon: boolean } => {
  const cleanGrapheme = normalize(grapheme);
  const allowsWhitespace = whitespaceAllowedProductIds.includes(String(props.productID));

  if (!allowsWhitespace && /\s/u.test(grapheme)) {
    return { valid: false, isIcon: false };
  }

  const isIcon = isSymbolCharacter(grapheme, cleanGrapheme);
  if (isIcon) {
    if (!allowedSymbols.value.includes(cleanGrapheme)) {
      return { valid: false, isIcon: true };
    }
    if (currentIconCount >= maxIcons) {
      return { valid: false, isIcon: true };
    }
    return { valid: true, isIcon: true };
  }

  const latinRegex = allowsWhitespace ? /^[\p{Script=Latin}0-9\s]$/u : /^\p{Script=Latin}$/u;
  const isLatin = latinRegex.test(grapheme) && !chineseRegex.test(grapheme);

  if (props.nameinput === 'back-namenecklace-input') {
    return { valid: isLatin || chineseRegex.test(grapheme), isIcon: false };
  } else if (props.isChina === 'yes') {
    return { valid: (allowsWhitespace && /\s/u.test(grapheme)) || chineseRegex.test(grapheme), isIcon: false };
  } else {
    return { valid: isLatin, isIcon: false };
  }
};

const filterInput = (str: string): string => {
  if (!str) return '';

  const graphemes = getGraphemes(str);
  let iconCount = 0;
  const maxIcons = limit_icon.value;

  const filtered = graphemes.filter(grapheme => {
    const { valid, isIcon } = isGraphemeValid(grapheme, iconCount, maxIcons);
    if (valid && isIcon) {
      iconCount++;
    }
    return valid;
  });

  return filtered.join('');
};

const handleBeforeInput = (e: Event) => {
  const inputEvent = e as InputEvent;
  if (!inputEvent.data) return;

  // Don't block delete or undo operations
  if (inputEvent.inputType && inputEvent.inputType.startsWith('delete')) {
    return;
  }

  const graphemes = getGraphemes(inputEvent.data);
  let currentIcons = countIcons(inputValue.value);
  const maxIcons = limit_icon.value;

  for (const g of graphemes) {
    const { valid, isIcon } = isGraphemeValid(g, currentIcons, maxIcons);
    if (!valid) {
      inputEvent.preventDefault();
      return;
    }
    if (isIcon) {
      currentIcons++;
    }
  }
};

const handlePreviewInput = (event?: Event) => {
  handleInput(event)
}

// end preview fontvisual

// ─── Template Refs ────────────────────────────────────────────────────────────
// Each instance component has its own unique refs → no confusion between Form 1 and Form 2.
const formWrapperRef = ref<HTMLElement | null>(null)
const symbolsPanelRef = ref<HTMLElement | null>(null)
const symbolsButtonRef = ref<HTMLElement | null>(null)

// ─── State ────────────────────────────────────────────────────────────────────
const rawValue = ref(props.valueinput)
const inputValue = ref(props.valueinput)

watch(() => props.valueinput, (value) => {
  if (value === inputValue.value) return
  rawValue.value = value
  inputValue.value = applyFontCase(value)
})

watch(() => props.fontSelected, () => {
  const currentVal = rawValue.value || inputValue.value
  if (!currentVal) return
  rawValue.value = currentVal
  inputValue.value = applyFontCase(currentVal)

  if (inputTimer) {
    clearTimeout(inputTimer)
  }
  emit('input-name', Number(props.index) || 0, inputValue.value)
  emit('update-name', Number(props.index) || 0, inputValue.value)
})
const showSymbolsPanel = ref(false)
//const selectedFont    = ref('Allura')
const currentMaxLength = ref(0);

// ─── Computed ─────────────────────────────────────────────────────────────────
//const inputLength = computed(() => inputValue.value.length)
const inputLength = computed(() => {
  return normalize(inputValue.value).length;
});

const icons = computed(() => {
  if (!props.symbols) return []
  return props.symbols.split(',').map(symbol => ({ value: symbol.trim() }))
})

const isIconAdded = computed(() => {
  return countIcons(inputValue.value) >= limit_icon.value
})

const previewSegments = computed(() => {
  const segments: Array<{ type: 'text' | 'icon'; value: string }> = []
  let text = ''

  getGraphemes(inputValue.value).forEach((grapheme) => {
    const isAllowedIcon = allowedSymbols.value.includes(normalize(grapheme))

    if (isAllowedIcon) {
      if (text) {
        segments.push({ type: 'text', value: text })
        text = ''
      }
      segments.push({ type: 'icon', value: grapheme })
      return
    }

    text += grapheme
  })

  if (text) {
    segments.push({ type: 'text', value: text })
  }

  return segments
})

const instanceId = Math.random().toString(36).substring(2, 9);

// ─── Symbols Panel ────────────────────────────────────────────────────────────
const toggleSymbols = () => {
  showSymbolsPanel.value = !showSymbolsPanel.value
  if (showSymbolsPanel.value && typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('close-all-necklace-symbols', { detail: instanceId }))
  }
}

const handleOtherSymbolsOpened = (e: Event) => {
  const customEvent = e as CustomEvent
  if (customEvent.detail !== instanceId) {
    showSymbolsPanel.value = false
  }
}

const insertSymbol = (symbol: string) => {
  const cleanSymbol = normalize(symbol);
  if (!allowedSymbols.value.includes(cleanSymbol)) return;

  if (countIcons(inputValue.value) >= limit_icon.value) {
    return;
  }

  if (normalize(inputValue.value).length < currentMaxLength.value) {
    inputValue.value += symbol
    handleInput()
    showSymbolsPanel.value = true
  }
}
// ─── Input Handling ───────────────────────────────────────────────────────────
let inputTimer: ReturnType<typeof setTimeout> | null = null

const applyFontCase = (str: string): string => {
  if (!str) return str

  if (props.fontSelected === 'calibri-1pt' || props.fontSelected === 'perpetua-bold') {
    return str.toUpperCase()
  }

  if (props.fontSelected === 'autography' || props.fontSelected === 'allura-3pt' || props.fontSelected === 'yellowtail' || props.fontSelected === 'brush-script') {
    const graphemes = getGraphemes(str)
    let firstFound = false
    return graphemes
      .map((g) => {
        if (allowedSymbols.value.includes(normalize(g))) {
          return g
        }
        if (!firstFound && /[a-zA-Z]/i.test(g)) {
          firstFound = true
          return g.toUpperCase()
        }
        return g.toLowerCase()
      })
      .join('')
  }

  return str
}

const handleInput = (event?: Event) => {
  const target = event?.target as HTMLInputElement | HTMLTextAreaElement | undefined
  // v-model waits for compositionend; use the current text while the user types.
  const filtered = filterInput(target?.value ?? inputValue.value)
  const graphemes = getGraphemes(filtered)
  let result = filtered

  if (graphemes.length > currentMaxLength.value) {
    result = graphemes.slice(0, currentMaxLength.value).join('')
  }

  rawValue.value = result
  inputValue.value = applyFontCase(result)

  if (target && !(event as InputEvent).isComposing && target.value !== inputValue.value) {
    target.value = inputValue.value
  }

  // Keep cart data current independently of the debounced price update below.
  emit('input-name', Number(props.index) || 0, inputValue.value)
  updateLengthSelection()

  // Clear timer cũ
  if (inputTimer) {
    clearTimeout(inputTimer)
  }

  inputTimer = setTimeout(() => {
    emit('update-name', Number(props.index) || 0, inputValue.value)
  }, 500)
}

// ─── Scope helpers ────────────────────────────────────────────────────────────
// Find the nearest parent product form to scope querySelector, avoiding impact on other instances.
const getProductScope = (): Element | Document => {
  return formWrapperRef.value?.closest('[data-product-form]') ?? document
}

// ─── Length Selection ─────────────────────────────────────────────────────────
const updateLengthSelection = () => {
  const id = props.id;
  if (id === 'namenecklace-main') {
    const length = normalize(inputValue.value).length
    const scope = getProductScope()
    const lengthItems = scope.querySelectorAll<HTMLElement>('.var-length-name li')

    lengthItems.forEach(item => {
      item.classList.remove('selected')
      const key = item.getAttribute('data-key')
      if (!key) return

      const [min, max] = key.split('-').map(Number)
      if (length >= min && length <= max) {
        item.classList.add('selected')
        item.click()
      }
    })
  }
}

// ─── Font Selection ───────────────────────────────────────────────────────────
const handleFontSelection = (event: Event) => {
  const target = event.target as HTMLElement
  if (!target.matches('.var-font-type li')) return

  const scope = getProductScope()
  scope.querySelectorAll('.var-font-type li').forEach(item => {
    item.classList.remove('selected')
  })
  target.classList.add('selected')
}

// ─── Click Outside ────────────────────────────────────────────────────────────
// Use direct references instead of querySelector → each instance manages its own panel.
const handleClickOutside = (event: MouseEvent) => {
  if (!showSymbolsPanel.value) return
  const target = event.target as Node | null
  if (!target) return
  if (
    symbolsPanelRef.value && !symbolsPanelRef.value.contains(target) &&
    symbolsButtonRef.value && !symbolsButtonRef.value.contains(target)
  ) {
    showSymbolsPanel.value = false
  }
}

// ─── Lifecycle ────────────────────────────────────────────────────────────────
onMounted(() => {
  // Apply the initial font-based case transform in case a font is already
  // selected and/or a value is prefilled when this component mounts.
  if (rawValue.value) {
    inputValue.value = applyFontCase(rawValue.value)
  }
  const scope = getProductScope()

  // Calculate currentMaxLength from the values ​​in the scope.
  const lengthElements = scope.querySelectorAll<HTMLElement>('.var-length-name li')
  let maxLength = 0

  if (lengthElements) {
  lengthElements.forEach(item => {
    const dataKey = item.getAttribute('data-key')
    if (!dataKey) return
    const rangeMax = Math.max(...dataKey.split('-').map(Number))
    maxLength = Math.max(maxLength, rangeMax)
  })
  }
  console.log('maxLength',maxLength,lengthElements);
if (maxLength) {
  currentMaxLength.value = Math.min(maxLength || 9, Number(props.maxlength))
} else {
  currentMaxLength.value  = Number(props.maxlength);
}
  

  // Initialize the default font from the first .li in the scope.
  // const firstFontEl = scope.querySelector<HTMLElement>('.var-font-type li')
  // if (firstFontEl) {
  //   selectedFont.value = firstFontEl.getAttribute('data-key') || 'Allura'
  //   firstFontEl.classList.add('selected')
  // }

  // Attach event listeners to the scope, not the entire document.
  scope.querySelector('.var-font-type')?.addEventListener('click', handleFontSelection)
  document.addEventListener('click', handleClickOutside, true)
  window.addEventListener('close-all-necklace-symbols', handleOtherSymbolsOpened)
})

onUnmounted(() => {
  const scope = getProductScope()
  scope.querySelector('.var-font-type')?.removeEventListener('click', handleFontSelection)
  document.removeEventListener('click', handleClickOutside, true)
  window.removeEventListener('close-all-necklace-symbols', handleOtherSymbolsOpened)
})
onBeforeUnmount(() => {
  if (inputTimer) {
    clearTimeout(inputTimer)
  }
})
</script>
<style lang="scss">
@font-face {
  font-family: "boldcn";
  src: url("~/assets/fonts/simsun.ttc") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "cursivecn";
  src: url("~/assets/fonts/STXINGKA.TTF") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "cursive-en";
  src: url("~/assets/fonts/SK_Cursive-Regular.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "allura-3pt";
  src: url("~/assets/fonts/customise/SK_SignatureScript-Regular.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "calibri-1pt";
  src: url("~/assets/fonts/customise/SK_BoldCapitalised-Regular.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "brush-script";
  src: url("~/assets/fonts/customise/SK_BoldScript-Regular.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "perpetua-bold";
  src: url("~/assets/fonts/customise/SK_KindredPair-Regular.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "autography";
  src: url("~/assets/fonts/customise/Autography.otf") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "yellowtail";
  src: url("~/assets/fonts/customise/SK_PeppyPals-Regular.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}



</style>

<style scoped lang="scss">
@import "@/assets/scss/components/product/_namenecklace.scss";

.necklace-icon {
  display: inline-block;
  font-family: Roboto, sans-serif;
}
</style>
